import React, { useState } from "react";

import { Button, ButtonToolbar, Loader } from "rsuite";
import Modal from "rsuite/Modal";

import useRequestHandler from "hooks/useRequestHandler";

const DeleteModal = ({
    auth,
    modalOpen,
    setModalOpen,
    contentLoader,
    apiName,
    apiArguments,
    successMessageData,
    errorMessageData,
    goBackUrl,
    children,
    history,
    refresh,
    setIsBatchDelete,
    setCheckedKeys }) => {

    const [loaderContent, setLoaderContent] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const deleteDataRequest = useRequestHandler({
        auth,
        apiArguments: [apiArguments],
        apiName,
        successMessageData: {
            message: successMessageData,
        },
        errorMessageData: {
            title: "Error",
            message: errorMessageData,
            type: "error"
        }
    });

    const deleteData = async () => {
        setLoaderContent(contentLoader);
        setIsLoading(true);
        await deleteDataRequest(data => {
            history.push(goBackUrl);
            closeModal();
            !!refresh && refresh();
            !!setIsBatchDelete && setIsBatchDelete(false);
            !!setCheckedKeys && setCheckedKeys([]);
        })
        setIsLoading(false);
    }

    const closeModal = () => setModalOpen(false);

    return (
        <Modal open={modalOpen} onClose={closeModal} className="delete-modal" size="sm">
            <Modal.Header></Modal.Header>
            <Modal.Body>
                <Modal.Title className="title">{children}</Modal.Title>
                {isLoading &&
                    <div className="loader-wrapper">
                        <Loader size="lg" center content={loaderContent} />
                    </div>}
            </Modal.Body>
            <Modal.Footer className={isLoading ? "hidden" : ""}>
                <ButtonToolbar className="btn-toolbar">
                    <Button
                        type="reset"
                        appearance="ghost"
                        size="lg"
                        className="delete-btn btn-cancel"
                        onClick={closeModal}
                    >Cancel</Button>
                    <Button
                        type="submit"
                        appearance="primary"
                        size="lg"
                        color="red"
                        className="delete-btn"
                        onClick={deleteData}
                    >Yes, Delete</Button>
                </ButtonToolbar>
            </Modal.Footer>
        </Modal>
    )
}

DeleteModal.defaultProps ={
    refresh: null,
    setIsBatchDelete: null,
    setCheckedKeys: null,
}

export default DeleteModal;
